module.exports = "../../app/cells/components/header/direcao_logos.erb";